import { useGet } from "@/api/lib/integration";
import type { PollingTopicIdentifier, PollingTopicState } from "@/api/polling/types";

export const getPollingState = useGet<null, Record<PollingTopicIdentifier, PollingTopicState<unknown>>>('/api/poll-state');
